<template>
<div class="chapter">
<div class="inner_page">
<p class="normal1-1"><span>“But if the while I think of thee, dear friend<br/>All losses are restored and sorrows end.”</span></p>
<p class="center-a"><span>Shakespeare, Sonnet 30, line 13</span></p>
<p class="center-b"><span>William E. Farrell, journalist,<br/>the <i>New York Times</i><br/>Joseph I. Grossman, sergeant, NYPD</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?d3a1c55c